import { MQ_BREAKPOINTS } from 'constants'

import forOwn from 'lodash/forOwn'
import isObject from 'lodash/isObject'
import isString from 'lodash/isString'
import isNumber from 'lodash/isNumber'
import mapKeys from 'lodash/mapKeys'

const ROMAN_NUMBERS = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII']

export const toRoman = (number) => ROMAN_NUMBERS[number - 1]

export function toCssClass(string) {
    return string.toLowerCase().replace(/_/g, '-')
}

export function serialize(obj) {
    let str = []
    for (let p in obj) {
        if (obj.hasOwnProperty(p) && obj[p] !== undefined) {
            const key = encodeURIComponent(p)

            if (Array.isArray(obj[p])){
                const value = obj[p]
                const serializedArray = value.map(encodeURIComponent).join(',')
                str.push(`${key}=${serializedArray}`)
            } else {
                str.push(`${key}=${encodeURIComponent(obj[p])}`)
            }
        }
    }

    return str.length ? `?${str.join('&')}` : ''
}

export const isFunction = (obj) => typeof obj === 'function'

// see tests for description
export function formatter(text) {
    return text
        .replace(/</g, '&lt;') // <
        .replace(/>/g, '&gt;') // >
        .replace(/(^|\W)\*(.+?[^\\])\*($|\W)/g, '$1<b>$2</b>$3') // format bold tag
        .replace(/"([^"]+?)":(http|https):\/\/([^\s]+)/g, '$1 ($2://$3)') // format links
        .replace(/(^|\W)\_(.+?[^\\])\_($|\W)/g, '$1$2$3') // strip italic tag
        .replace(/\\(.)/g, '$1') // ignored symbols
        .replace(/(\r)?\n/g, '<br>') // newline
}

export const mq = (size) => {
    const width = window.innerWidth
    const height = window.innerHeight

    switch (size) {
    case MQ_BREAKPOINTS.XXL:
        return width >= 2560 && height >= 1100
    case MQ_BREAKPOINTS.XL:
        return width >= 1920 && height >= 958
    case MQ_BREAKPOINTS.L:
        return width >= 1600 && height >= 926
    case MQ_BREAKPOINTS.M:
        return width >= 1440 && height >= 776
    case MQ_BREAKPOINTS.S:
        return width >= 1366 && height >= 646
    case MQ_BREAKPOINTS.XS:
        return width >= 1280 && height >= 900
    case MQ_BREAKPOINTS.XSS:
        return width >= 1024 && height >= 646
    default:
        return false
    }
}

const toCamelCaseRegex = /(\_\w)/g

const objectToCamelCase = function(object) {
    const newObject = {}
    if (isString(object) || isNumber(object)) {
        return object
    }
    forOwn(object, function(value, key) {
        if (Array.isArray(value) || isObject(value)) {
            newObject[key] = arrayOrObjectToCamelCase(value)
        } else {
            newObject[key] = value
        }
    })

    return mapKeys(newObject, (value, key) => {
        return stringToCamelCase(key)
    })
}
export function arrayOrObjectToCamelCase(objectOrArray) {
    if (Array.isArray(objectOrArray)) {
        return objectOrArray.map(objectToCamelCase)
    }
    if (isObject(objectOrArray)) {
        return objectToCamelCase(objectOrArray)
    }
}

function stringToCamelCase(string) {
    return string.replace(toCamelCaseRegex, matches => matches[1].toUpperCase())
}

export function isCnRealm(realm) {
    return (realm === 'cn360')
}



// WEBPACK FOOTER //
// ./helpers/index.js